export const PROFILE_FIELDS = `
  fragment ProfileFields on Profile {
    id
    givenName
    familyName
    username
    email
    gender
    birthdate
    phoneHome
    phoneMobile
    membershipId
    city
    region
    province
    countryCode
    country
    phonePreferred,
    ghaid
    brokers {
      companyId
    }
  }
`
